<template>
  <div class="modules">
    <h1 class="title">Modules de l'Agent IA</h1>
    <div class="module-grid">
      <div v-for="module in modules" :key="module.title" class="module-card">
        <h2>{{ module.title }}</h2>
        <p>{{ module.description }}</p>
        <button @click="openModal(module)">Configurer</button>
      </div>
    </div>

    <div class="modal-backdrop" v-if="showModal">
      <div class="modal-content">
        <h2>Configurer : {{ selectedModule?.title }}</h2>
        <p>{{ selectedModule?.description }}</p>

        <component :is="getConfigComponent(selectedModule.title)"
                   v-model="moduleSettings[selectedModule.title]" />

        <div class="modal-actions">
          <button @click="saveConfig">Sauvegarder</button>
          <button @click="closeModal" class="cancel">Annuler</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqConfig from '../modules/FaqConfig.vue'
import ABTestingConfig from '../modules/ABTestingConfig.vue'
import ResumeConfig from '../modules/ResumeConfig.vue'
import CollecteConfig from '../modules/CollecteConfig.vue'
import Cookies from 'js-cookie'


export default {
  name: 'ModulesComponent',
  components: {
    FaqConfig,
    CollecteConfig,
    ABTestingConfig,
    ResumeConfig
  },
  mounted () {
    const token = Cookies.get('token')
    if (!token) return this.$router.push('/sign-in')
  },
  data() {
    return {
      modules: [
        { title: 'FAQ intelligente', description: 'Répond automatiquement aux questions fréquentes.' },
        { title: 'Collecte de données', description: 'Capture les emails, noms, numéros, etc.' },
        { title: 'Messages personnalisés', description: 'Réponses adaptées selon le profil du client.' },
        { title: 'Détection d\'intention', description: 'Comprend le but de la question du client.' },
        { title: 'Relance automatique', description: 'Relance les clients sans réponse.' },
        { title: 'A/B Testing', description: 'Teste plusieurs réponses pour optimiser les conversions.' },
        { title: 'Routage vers humain', description: 'Transfère à un humain si nécessaire.' },
        { title: 'Multilingue', description: 'Supporte plusieurs langues automatiquement.' },
        { title: 'Analyse des émotions', description: 'Détecte le ton et adapte les réponses.' },
        { title: 'Résumé de conversation', description: 'Résume automatiquement les échanges passés.' }
      ],
      selectedModule: null,
      showModal: false,
      moduleSettings: {}
    }
  },
  methods: {
    openModal(module) {
      this.selectedModule = module
      if (!this.moduleSettings[module.title]) {
        this.moduleSettings[module.title] = {}
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedModule = null
    },
    saveConfig() {
      alert(`Configuration du module "${this.selectedModule.title}" sauvegardée.`)
      this.closeModal()
    },
    getConfigComponent(title) {
      const components = {
        'FAQ intelligente': 'FaqConfig',
        'Collecte de données': 'CollecteConfig',
        'A/B Testing': 'ABTestingConfig',
        'Résumé de conversation': 'ResumeConfig'
      }
      return components[title] || 'div'
    }
  }
}
</script>

<style scoped>
.modules {
  padding: 20px;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.stats-bar {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  font-size: 0.95rem;
  color: #4b5563;
}

.stat {
  background: #f3f4f6;
  padding: 10px 15px;
  border-radius: 6px;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.module-card {
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.module-card h2 {
  font-size: 1.25rem;
  margin-bottom: 10px;
}

.module-card p {
  flex-grow: 1;
  margin-bottom: 10px;
  color: #4b5563;
}

.module-card button {
  align-self: flex-start;
  background-color: #6366f1;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.module-card button:hover {
  background-color: #4f46e5;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-actions button {
  padding: 10px 16px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.modal-actions .cancel {
  background-color: #e5e7eb;
  color: #374151;
}

.modal-actions .cancel:hover {
  background-color: #d1d5db;
}

.modal-actions button:first-child {
  background-color: #6366f1;
  color: white;
}

.modal-actions button:first-child:hover {
  background-color: #4f46e5;
}

.form-group {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.form-group input,
.form-group select {
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
}
</style>
  